import axios, {
    AxiosInstance,
    AxiosRequestConfig,
    AxiosResponse
} from 'axios';
import { IAppInitConfig, IAppConfig } from 'types';

class ApiRequest {
    client: AxiosInstance;
    initUrl: string;
    configUrl: string;
    gpConfigUrl: string;

    constructor() {
        this.client = axios.create({});
    }

    initApiClient(projectId: string, mapCode: string, publicMapHost: string): void {
        if (__PROXY_URL__) {
            this.initUrl = `${__PROXY_URL__}/orbismap/public_map/${projectId}/${mapCode}/init.json`;
            this.configUrl = `${__PROXY_URL__}/orbismap/public_map/${projectId}/${mapCode}/config.json`;
            this.gpConfigUrl = `${__PROXY_URL__}/orbismap/public_map/${projectId}/gen_plans/config.json`;
        } else {
            this.initUrl = `//${publicMapHost}/public_map/${projectId}/${mapCode}/init.json`;
            this.configUrl = `//${publicMapHost}/public_map/${projectId}/${mapCode}/config.json`;
            this.gpConfigUrl = `//${publicMapHost}/public_map/${projectId}/gen_plans/config.json`;
        }
        // this.client.defaults.baseURL = `${apiUrl}${this.version}/`;
    }

    setOmsApiBaseUrl(url) {
        this.client.defaults.baseURL = url;
    }

    async getInitConfig(): Promise<AxiosResponse<IAppInitConfig>> {
        return axios.get(this.initUrl);
    }

    async getConfig(token?: string): Promise<AxiosResponse<IAppConfig>> {
        let params = {};

        if (token) {
            params['token'] = token;
        }

        return axios.get(this.configUrl, { params });
    }

    async getGpConfig(token?: string): Promise<AxiosResponse<IAppConfig>> {
        let params = {};

        if (token) {
            params['token'] = token;
        }

        return axios.get(this.gpConfigUrl, { params });
    }
}

export const apiRequest = new ApiRequest();
